import moment from "moment";
import { GET_TWT_SESSIONS, GET_TWT_SESSIONS_SUCCESS, GET_TWT_SESSIONS_FAILURE, TRIGGER_TOAST } from "../constants";
import Axios from "axios";
import { twtSessionsDays } from "../../globalConstants";

const getTWTSessions = () => {
  return async (dispatch: any) => {
    dispatch({ type: GET_TWT_SESSIONS });
    let options = {
        headers: {
        'fromTime' : moment().valueOf(), 
        'toTime': moment().add(twtSessionsDays, 'days').endOf('day').valueOf(),
        "content-type": "application/json"
      }
    }
    await Axios.get(`https://qaroomsadmin.globalenglish.com/rest/v1/sessions/students-schedule-lite`, options).then((response) => {
      dispatch({ type: GET_TWT_SESSIONS_SUCCESS, payload: [ ...response.data ] });
    }).catch((err: any) => {
      console.log(err)
      dispatch({ type: GET_TWT_SESSIONS_FAILURE });
      dispatch({
        type: TRIGGER_TOAST,
        payload: {
          shouldShow: true,
          severity : 'error',
          transMessage: "message_errorDefault"
        },
      });
    }); 
  };
};
  
export default { getTWTSessions };
  